<template>
  <div v-if="isLoading" class="spinner-with-message" :class="className">
        <spinner />
        <span>{{message}}</span>
    </div>
</template>

<script>

import Spinner from 'shared/components/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    message: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.spinner-with-message {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
//   padding: 2rem;
  font-size: 14px;
}

</style>